import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Title, Card, Box, Text, SimpleGrid } from '@mantine/core';

import Find from './Find';
import * as actions from '../../../actions/Lote';
import InnerView from './InnerView';
import { DetailSkeleton } from '../../../components/TableSkeleton';
import { useAppDispatch } from '../../../store/hooks';
import { useOptionalNavegadorMap } from '../../../components/Navegador/NavegadorMapContext';
import type { Unidade } from '../../../store/types';

import './View.less';

export default function ImovelView() {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();

  const [unidade, setUnidade] = useState<Unidade | null>(null);

  useEffect(() => {
    if (!id) return;
    dispatch((actions as any).getUnidade(id, '[VIEW]', (response: { data: Unidade }) => {
      setUnidade(response.data);
    }));

    return () => {
      dispatch((actions as any).clear());
    };
  }, [id, dispatch]);

  const inShell = !!useOptionalNavegadorMap();

  if (!unidade) return <DetailSkeleton lines={10} />;

  return (
    <Box>
      {!inShell && (
        <>
          <Title order={1}>Navegador GeoFinanceiro Unidade {unidade.inscricao}</Title>
          <Find />
        </>
      )}

      <Card withBorder shadow="sm" padding="md" mt="md" mb="xl">
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
          {unidade.fieldItemGroups.map((itemGroup) =>
            itemGroup.fieldItems.map((fieldItem) => (
              <Box key={fieldItem.label}>
                <Text size="sm">
                  <Text component="span" fw={600}>{fieldItem.label}: </Text>
                  {fieldItem.value}
                </Text>
              </Box>
            ))
          )}
        </SimpleGrid>
      </Card>

      <InnerView unidadeId={unidade.id} />
    </Box>
  );
}
